import { RootState } from '@reducers';

export const selectInsurancePolicyBuyRoute = (state: RootState) => state.insurancePolicyBuyRouteReducer;
